exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "section.app-header[data-v-7086a353]{position:fixed;top:0;width:100%;background-color:var(--dark-color)}div[data-v-7086a353]{width:120px;height:120px}.logo[data-v-7086a353]{width:80px}h1[data-v-7086a353]{margin-left:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7086a353","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/Header.vue
// module id = 320
// module chunks = 0